// DS: i3.23
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const AddedToFav: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.504 7.5a1 1 0 01.881.528l1.73 3.231 3.834.514a1 1 0 01.814.667l.363 1.063a1 1 0 01-.278 1.067l-2.707 2.432.642 3.452a1 1 0 01-.415 1.006l-1.027.709a1 1 0 01-1.004.077L9.84 20.552l-3.497 1.694a1 1 0 01-1.004-.077l-1.027-.709a1 1 0 01-.415-1.006l.642-3.452-2.707-2.432a1 1 0 01-.278-1.067l.363-1.063a1 1 0 01.814-.667l3.833-.514 1.73-3.231a1 1 0 01.882-.528h1.328zm7.836-6a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 010-2h2v-2a1 1 0 011-1z"
          fillRule="evenodd"
        />
      </svg>
    </IconWrap>
  );
};
AddedToFav.displayName = 'AddedToFav';
export default AddedToFav;
